import { testId } from '../../utils';
import {
  type SidebarItem,
  type SidebarCategory,
  SidebarCategoryItem,
  SidebarLinkItem,
} from './SidebarItem';
import * as RadixNavigationMenu from '@radix-ui/react-navigation-menu';
import clsx from 'clsx';
import React from 'react';
import { useMatches } from 'react-router-dom';

const SIDEBAR_ITEMS: (SidebarCategory | SidebarItem)[] = [
  {
    title: 'dashboard',
    path: '/user/dashboard',
    iconKey: 'home',
  },
  {
    title: 'projects',
    path: '/user/projects',
    iconKey: 'folder_copy',
  },
  {
    title: 'account',
    iconKey: 'account_circle',
    pathPrefix: '/user/account',
    children: [
      {
        title: 'orders',
        path: '/orders',
      },
      {
        title: 'settings',
        path: '/settings',
      },
      {
        title: 'address_book',
        path: '/address-book',
      },
      {
        title: 'profile',
        path: '/profile',
      },
    ],
  },
];

type SidebarProps = {
  className?: string;
};

export const Sidebar: React.FC<SidebarProps> = ({ className }) => {
  const matches = useMatches();
  return (
    <RadixNavigationMenu.Root
      {...testId('sidebar')}
      defaultValue={matches[0].pathname}
      className={clsx(
        'h-full min-w-64 px-2 bg-white border-l border-gray-light md:border-r z-10 md:z-0',
        className,
      )}
      orientation="vertical"
    >
      <RadixNavigationMenu.List className="flex flex-col gap-4 mt-4 md:mt-2">
        {SIDEBAR_ITEMS.map((item, index) => {
          if (item.children) {
            return <SidebarCategoryItem {...item} key={index} />;
          }

          return <SidebarLinkItem {...item} key={index} />;
        })}
      </RadixNavigationMenu.List>
    </RadixNavigationMenu.Root>
  );
};
